import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import { Popup } from 'components';
import { callApi } from 'utils';

const GroupSchedule = ({group, onClose}) => {
  const gid = group?.gid;
  const [jobs, setJobs] = useState([]);

  useEffect(() => void(
    gid && callApi(`/jobs?gid=${gid}&groupschedules=1`).then(res => setJobs(res)).catch(console.error)
  ), [gid]);

  if (!gid)
    return null;

  const dates = new Set();
  const schedules = [];

  jobs.forEach(job => {
    const startDate = dayjs(job.start_date), endDate = dayjs(job.end_date);
    const row = {id: job.id};
    for (let d = startDate; !d.isAfter(endDate, 'day'); d = d.add(1, 'day')) {
      const ymd = d.format('YYYYMMDD');
      const imps = isNaN(job.daily_imps[ymd]) ? job.daily_imps.default : job.daily_imps[ymd];
      if (imps) {
        const key = d.format('YY-MM-DD');
        dates.add(key);
        row[key] = imps;
      }
    }
    schedules.push(row);
  });

  const days = [...dates].sort();

  return (
    <Popup
      open={Boolean(group)}
      onClose={onClose}
      title={`${gid} - ${group.name}`}
      styles={{width: 'auto', maxWidth: '85%'}}
    >
      <Box sx={{width: '100%', overflow: 'scroll'}}>
        <Table size="small" sx={{
          mb: '12px',
          '& th,td': {
            textAlign: 'center',
          }
        }}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              { days.map(day => (<TableCell key={day}>{day.slice(3)}</TableCell>)) }
            </TableRow>
          </TableHead>
          <TableBody>
          {schedules.map(row => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              { days.map(day => (<TableCell key={day}>{row[day]||'--'}</TableCell>)) }
            </TableRow>
          ))}
          </TableBody>
        </Table>
      </Box>
    </Popup>
  );
};

export default GroupSchedule;
